import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Release } from "../../services/releases";
import Modal, { ModalButton, ModalSecondaryButton } from "../Modal";

const prefix = "components.releaseAnnouncement";

const Cover = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  border-radius: 12px;
`;

const Summary = styled.p`
  font-family: Inter, sans-serif;
  font-size: 0.9375rem;
  line-height: 1.5rem;
  color: rgba(255, 255, 255, 0.8);
`;

type Props = {
  release: Release;
  /** "See what's new": the list opens (which counts as seen) */
  onOpen: () => void;
  /** Closed by "Close", the X, Escape or a click outside: it doesn't come back */
  onClose: () => void;
};

/** A launch the person wasn't told about yet: its picture, title and summary, and a way to the whole news. */
const ReleaseAnnouncement = ({ release, onOpen, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      outsideExit
      onExit={onClose}
      eyebrow={t(`${prefix}.eyebrow`)}
      title={release.title}
      footer={
        <>
          <ModalSecondaryButton type="button" onClick={onClose}>
            {t(`${prefix}.close`)}
          </ModalSecondaryButton>
          <ModalButton onClick={onOpen}>{t(`${prefix}.open`)}</ModalButton>
        </>
      }>
      {release.image && <Cover src={release.image.url} alt={release.image.alt || release.title} />}
      {release.summary && <Summary>{release.summary}</Summary>}
    </Modal>
  );
};

export default ReleaseAnnouncement;
